import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';

export function canNavigateReducer(sectionState: boolean = false, action: AnyAction): boolean {
  switch (action.type) {
    case GlobalActions.NAVIGATION_REQUESTED: {
      return true;
    }
    case GlobalActions.LOCATION_CHANGED: {
      return false;
    }
    default:
      return sectionState;
  }
}
